/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/routes/__root'
import { Route as LoginRouteImport } from './../../pages/routes/login'
import { Route as AuthenticatedRouteImport } from './../../pages/routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './../../pages/routes/_authenticated/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './../../pages/routes/_authenticated/projects.index'
import { Route as AuthenticatedProjectsProjectIdIndexRouteImport } from './../../pages/routes/_authenticated/projects.$projectId.index'
import { Route as AuthenticatedProjectsProjectIdHistoryRouteImport } from './../../pages/routes/_authenticated/projects.$projectId.history'
import { Route as AuthenticatedProjectsProjectIdLogNewRouteImport } from './../../pages/routes/_authenticated/projects.$projectId.log.new'
import { Route as AuthenticatedProjectsProjectIdLogLogIdIndexRouteImport } from './../../pages/routes/_authenticated/projects.$projectId.log.$logId.index'
import { Route as AuthenticatedProjectsProjectIdLogLogIdEditRouteImport } from './../../pages/routes/_authenticated/projects.$projectId.log.$logId.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdIndexRoute =
  AuthenticatedProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdHistoryRoute =
  AuthenticatedProjectsProjectIdHistoryRouteImport.update({
    id: '/projects/$projectId/history',
    path: '/projects/$projectId/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdLogNewRoute =
  AuthenticatedProjectsProjectIdLogNewRouteImport.update({
    id: '/projects/$projectId/log/new',
    path: '/projects/$projectId/log/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdLogLogIdIndexRoute =
  AuthenticatedProjectsProjectIdLogLogIdIndexRouteImport.update({
    id: '/projects/$projectId/log/$logId/',
    path: '/projects/$projectId/log/$logId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdLogLogIdEditRoute =
  AuthenticatedProjectsProjectIdLogLogIdEditRouteImport.update({
    id: '/projects/$projectId/log/$logId/edit',
    path: '/projects/$projectId/log/$logId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/projects/$projectId/history': typeof AuthenticatedProjectsProjectIdHistoryRoute
  '/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/projects/$projectId/log/new': typeof AuthenticatedProjectsProjectIdLogNewRoute
  '/projects/$projectId/log/$logId/edit': typeof AuthenticatedProjectsProjectIdLogLogIdEditRoute
  '/projects/$projectId/log/$logId/': typeof AuthenticatedProjectsProjectIdLogLogIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/projects/$projectId/history': typeof AuthenticatedProjectsProjectIdHistoryRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/projects/$projectId/log/new': typeof AuthenticatedProjectsProjectIdLogNewRoute
  '/projects/$projectId/log/$logId/edit': typeof AuthenticatedProjectsProjectIdLogLogIdEditRoute
  '/projects/$projectId/log/$logId': typeof AuthenticatedProjectsProjectIdLogLogIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/projects/$projectId/history': typeof AuthenticatedProjectsProjectIdHistoryRoute
  '/_authenticated/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/_authenticated/projects/$projectId/log/new': typeof AuthenticatedProjectsProjectIdLogNewRoute
  '/_authenticated/projects/$projectId/log/$logId/edit': typeof AuthenticatedProjectsProjectIdLogLogIdEditRoute
  '/_authenticated/projects/$projectId/log/$logId/': typeof AuthenticatedProjectsProjectIdLogLogIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/projects/'
    | '/projects/$projectId/history'
    | '/projects/$projectId/'
    | '/projects/$projectId/log/new'
    | '/projects/$projectId/log/$logId/edit'
    | '/projects/$projectId/log/$logId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/projects'
    | '/projects/$projectId/history'
    | '/projects/$projectId'
    | '/projects/$projectId/log/new'
    | '/projects/$projectId/log/$logId/edit'
    | '/projects/$projectId/log/$logId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/'
    | '/_authenticated/projects/'
    | '/_authenticated/projects/$projectId/history'
    | '/_authenticated/projects/$projectId/'
    | '/_authenticated/projects/$projectId/log/new'
    | '/_authenticated/projects/$projectId/log/$logId/edit'
    | '/_authenticated/projects/$projectId/log/$logId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/': {
      id: '/_authenticated/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/history': {
      id: '/_authenticated/projects/$projectId/history'
      path: '/projects/$projectId/history'
      fullPath: '/projects/$projectId/history'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/log/new': {
      id: '/_authenticated/projects/$projectId/log/new'
      path: '/projects/$projectId/log/new'
      fullPath: '/projects/$projectId/log/new'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdLogNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/log/$logId/': {
      id: '/_authenticated/projects/$projectId/log/$logId/'
      path: '/projects/$projectId/log/$logId'
      fullPath: '/projects/$projectId/log/$logId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdLogLogIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/log/$logId/edit': {
      id: '/_authenticated/projects/$projectId/log/$logId/edit'
      path: '/projects/$projectId/log/$logId/edit'
      fullPath: '/projects/$projectId/log/$logId/edit'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdLogLogIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedProjectsProjectIdHistoryRoute: typeof AuthenticatedProjectsProjectIdHistoryRoute
  AuthenticatedProjectsProjectIdIndexRoute: typeof AuthenticatedProjectsProjectIdIndexRoute
  AuthenticatedProjectsProjectIdLogNewRoute: typeof AuthenticatedProjectsProjectIdLogNewRoute
  AuthenticatedProjectsProjectIdLogLogIdEditRoute: typeof AuthenticatedProjectsProjectIdLogLogIdEditRoute
  AuthenticatedProjectsProjectIdLogLogIdIndexRoute: typeof AuthenticatedProjectsProjectIdLogLogIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedProjectsProjectIdHistoryRoute:
    AuthenticatedProjectsProjectIdHistoryRoute,
  AuthenticatedProjectsProjectIdIndexRoute:
    AuthenticatedProjectsProjectIdIndexRoute,
  AuthenticatedProjectsProjectIdLogNewRoute:
    AuthenticatedProjectsProjectIdLogNewRoute,
  AuthenticatedProjectsProjectIdLogLogIdEditRoute:
    AuthenticatedProjectsProjectIdLogLogIdEditRoute,
  AuthenticatedProjectsProjectIdLogLogIdIndexRoute:
    AuthenticatedProjectsProjectIdLogLogIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
